export default __webpack_public_path__ + "static/media/Thug's Veil of the Grim Cabal.b1f3dc5a.jpg";